// Generated by scripts/generate-media.cjs. Do not edit by hand.
export const publicMedia = [
  { id: "m-3fc397c78976de9c", batchId: "b-89bbfb668eea", category: "ceramics" },
  { id: "m-5281413ab750d534", batchId: "b-89bbfb668eea", category: "ceramics" },
  { id: "m-c6cc6529b3872680", batchId: "b-89bbfb668eea", category: "ceramics" },
  { id: "m-92a3ea47aa6469f8", batchId: "b-bb5c0141d85f", category: "ceramics" },
  { id: "m-8024321ef44fed38", batchId: "b-bb5c0141d85f", category: "ceramics" },
  { id: "m-2d94933e51e40e7b", batchId: "b-bb5c0141d85f", category: "ceramics" },
  { id: "m-42d3d8d8206ba452", batchId: "b-bb5c0141d85f", category: "ceramics" },
  {
    id: "m-049a2d4510d9cfc1",
    batchId: "b-14f7530c84cc",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-9f6f639f4c4d9e00",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-9cacd47df8e561de",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-668c87f6965c4ae9",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-09a093d47ec4eeec",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-0286e349e3de5735",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-a6cb8ba3ea87882e",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-8adaa7f70546bdf8",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-c868f66c1ea09364",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-f4365a2275a99209",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-1c1923701001e75a",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-e54aa7d31b4b3b0f",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  {
    id: "m-7f5be489029f3574",
    batchId: "b-4185b6c84e45",
    category: "ceramics",
    relatedProject: "burtu-miskas",
  },
  { id: "m-f992f13316bc1dbb", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-4bb5adc06ada6499", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-a9dafeb09e82c727", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-0ff7a46d14c94015", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-def7414e3125c77b", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-369b5bd791d783e9", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-54e2ea8097520b79", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-7690b15a1d4e96ab", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-44bc0599cdd0114e", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-addf5c293ecc0b06", batchId: "b-5bafdc9d3bf3", category: "ceramics" },
  { id: "m-864c537c9c313b48", batchId: "b-5975cc409c7f", category: "ceramics" },
  { id: "m-ddd67498f07febc2", batchId: "b-5975cc409c7f", category: "ceramics" },
  { id: "m-7b2e4751bbe4342f", batchId: "b-5975cc409c7f", category: "ceramics" },
  { id: "m-38f860fa54766a6f", batchId: "b-5975cc409c7f", category: "ceramics" },
  { id: "m-596b1824a0efb0b5", batchId: "b-38a7827c8e41", category: "ceramics" },
  { id: "m-6f5c9bb303078fc2", batchId: "b-38a7827c8e41", category: "ceramics" },
  { id: "m-43fdc87ddb774cf3", batchId: "b-38a7827c8e41", category: "ceramics" },
  { id: "m-616c0c9725c17f75", batchId: "b-d1e53c258cf0", category: "ceramics" },
  { id: "m-9c128d110d15c183", batchId: "b-d1e53c258cf0", category: "ceramics" },
  { id: "m-26a73b7c8c67ca34", batchId: "b-d1e53c258cf0", category: "ceramics" },
  { id: "m-19d36bed402795c5", batchId: "b-99416d8b6a36", category: "ceramics" },
  { id: "m-7e5a904b1f0d91d1", batchId: "b-99416d8b6a36", category: "ceramics" },
  { id: "m-28073bfd729e1ff6", batchId: "b-99416d8b6a36", category: "ceramics" },
  { id: "m-f91848bbf8f90a1b", batchId: "b-4fff1693013e", category: "ceramics" },
  { id: "m-3b22f5a2088dacd8", batchId: "b-4fff1693013e", category: "ceramics" },
  { id: "m-c5d4985bcdd12589", batchId: "b-f2d5e508f8c4", category: "ceramics" },
  { id: "m-05d31cd2af1f75c0", batchId: "b-f2d5e508f8c4", category: "ceramics" },
  { id: "m-bd6f2e2201b87eaa", batchId: "b-f2d5e508f8c4", category: "ceramics" },
  { id: "m-cceb505178af125f", batchId: "b-f2d5e508f8c4", category: "ceramics" },
  { id: "m-2773f15a6acb69d8", batchId: "b-f2d5e508f8c4", category: "ceramics" },
  { id: "m-6b0e6e90f556b3a9", batchId: "b-f2d5e508f8c4", category: "ceramics" },
  { id: "m-8d6b003af9c13f39", batchId: "b-e1814c400625", category: "other" },
  { id: "m-a4ef6ea3232b8b3f", batchId: "b-e1814c400625", category: "other" },
  { id: "m-d49551040c590f05", batchId: "b-eae074b8233c", category: "fluxus" },
  { id: "m-7cb6f47498d6961e", batchId: "b-eae074b8233c", category: "fluxus" },
  { id: "m-08c03e5d7d21a9e6", batchId: "b-eae074b8233c", category: "fluxus" },
  { id: "m-62ad199dc46e7883", batchId: "b-eae074b8233c", category: "fluxus" },
  { id: "m-fe5ecc46c91d3050", batchId: "b-eae074b8233c", category: "fluxus" },
  { id: "m-f05dc6d45b64c9c4", batchId: "b-eae074b8233c", category: "fluxus" },
  { id: "m-b05a1f4f69d73368", batchId: "b-ada782a8f529", category: "painting" },
  { id: "m-4ea28a62c48b03e0", batchId: "b-ada782a8f529", category: "painting" },
  { id: "m-3666c586af0d9b2f", batchId: "b-ada782a8f529", category: "painting" },
  { id: "m-95dc523746bd3d9d", batchId: "b-9acd13976f5d", category: "painting" },
  { id: "m-2fd3a5bb04b57bd4", batchId: "b-9acd13976f5d", category: "painting" },
  { id: "m-0dd015d7bcba3a84", batchId: "b-fc1bfa3ced64", category: "painting" },
  { id: "m-523b056ce089615f", batchId: "b-fc1bfa3ced64", category: "painting" },
  { id: "m-1a9b52aa90bbe8ae", batchId: "b-fc1bfa3ced64", category: "painting" },
  { id: "m-9594cc103b76a489", batchId: "b-6de0c9e53e20", category: "painting" },
  { id: "m-002a24ae0bf691e3", batchId: "b-6de0c9e53e20", category: "painting" },
  { id: "m-9af0a8bcb5ca19aa", batchId: "b-6de0c9e53e20", category: "painting" },
  { id: "m-714117cb0e836a1a", batchId: "b-13ffbc87599e", category: "painting" },
  { id: "m-da2fdfcacdb80970", batchId: "b-13ffbc87599e", category: "painting" },
  { id: "m-f5dc93e6b8ec6e62", batchId: "b-c43c800f7544", category: "painting" },
  { id: "m-c32359c5c02cd000", batchId: "b-c43c800f7544", category: "painting" },
  { id: "m-e188fc51cebf7303", batchId: "b-c43c800f7544", category: "painting" },
  { id: "m-cfc20fee5215566a", batchId: "b-c43c800f7544", category: "painting" },
  { id: "m-2c256c1e029ea131", batchId: "b-c43c800f7544", category: "painting" },
  { id: "m-aab76b1bc1a06d7f", batchId: "b-c43c800f7544", category: "painting" },
  { id: "m-0be2bb7682af2595", batchId: "b-0acc8d904eef", category: "painting" },
  { id: "m-0d331b30725251ad", batchId: "b-0acc8d904eef", category: "painting" },
  { id: "m-171d9b2d5df18499", batchId: "b-0acc8d904eef", category: "painting" },
  { id: "m-8bd98a1e269daac4", batchId: "b-ac8c9e1e763d", category: "painting" },
  { id: "m-d0a1dbdfb58ce37b", batchId: "b-d2286a218388", category: "other" },
  { id: "m-31136270629bca6b", batchId: "b-d2286a218388", category: "other" },
  { id: "m-640c46cc6ed7634d", batchId: "b-d2286a218388", category: "other" },
  { id: "m-87c583abae2592ca", batchId: "b-d2286a218388", category: "other" },
  { id: "m-15d7ad456d345f1d", batchId: "b-d2286a218388", category: "other" },
  { id: "m-3f118333881fcbe3", batchId: "b-d2286a218388", category: "other" },
  { id: "m-eeed7de404a9edd5", batchId: "b-d2286a218388", category: "other" },
  { id: "m-1cad11b421fd1ebd", batchId: "b-d2286a218388", category: "other" },
  { id: "m-876da1a93e876879", batchId: "b-d2286a218388", category: "other" },
  { id: "m-b130a07f4bef690c", batchId: "b-d2286a218388", category: "other" },
  { id: "m-a59684d42c21094d", batchId: "b-d2286a218388", category: "other" },
  { id: "m-00b8651430115a77", batchId: "b-d2286a218388", category: "other" },
  { id: "m-3434e5e898c5de7f", batchId: "b-d2286a218388", category: "other" },
  { id: "m-4eca68ded662717c", batchId: "b-d2286a218388", category: "other" },
  { id: "m-1f7c5439c0903f46", batchId: "b-d2286a218388", category: "other" },
  { id: "m-9846ce38e04edca4", batchId: "b-d2286a218388", category: "other" },
  { id: "m-6cba3b065602ee41", batchId: "b-d2286a218388", category: "other" },
  { id: "m-c744dc6a60bafcd0", batchId: "b-d2286a218388", category: "other" },
  { id: "m-d6d0830f6766babf", batchId: "b-d2286a218388", category: "other" },
  { id: "m-cc6d4679af386826", batchId: "b-d2286a218388", category: "other" },
  { id: "m-fd44a1c00db2c778", batchId: "b-d2286a218388", category: "other" },
  { id: "m-4b971b1fb34f9943", batchId: "b-d2286a218388", category: "other" },
  { id: "m-7fcb0ac0abe494fe", batchId: "b-d2286a218388", category: "other" },
  { id: "m-18f899b1c1f318c5", batchId: "b-4ea59707eb43", category: "other" },
  { id: "m-c9f4f0fee2c12280", batchId: "b-4ea59707eb43", category: "other" },
  { id: "m-4e33625ca053390a", batchId: "b-4ea59707eb43", category: "other" },
  { id: "m-0e6f7270ef5328ac", batchId: "b-4ea59707eb43", category: "other" },
  {
    id: "m-1492b4bccff90fc9",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260921_091530.jpg",
  },
  {
    id: "m-5ef0e70e739f86ef",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260921_104058.jpg",
  },
  {
    id: "m-e0611f8a462da9b2",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260921_112433.jpg",
  },
  {
    id: "m-6d4d637ea4dcb854",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260921_162626.jpg",
  },
  {
    id: "m-a4aaf578c3dcf88b",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260923_212436.jpg",
  },
  {
    id: "m-e29a5ecf44d91dba",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260923_212502.jpg",
  },
  {
    id: "m-c2e749c00374867b",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260924_124705.jpg",
  },
  {
    id: "m-8869d2ecae0a527d",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260924_125635.jpg",
  },
  {
    id: "m-4ebde5c88c1fb27c",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260924_130205.jpg",
  },
  {
    id: "m-1ee705aa32861247",
    batchId: "owner-P2RnMId",
    category: "drawings",
    sourceFilename: "20260924_152501.jpg",
  },
  {
    id: "m-a49b2ecabcc8e387",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_160622.jpg",
  },
  {
    id: "m-ca39588fe005e2bb",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_160700.jpg",
  },
  {
    id: "m-0cc82255774883a0",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_160820.jpg",
  },
  {
    id: "m-299017177e0b29a2",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_160831.jpg",
  },
  {
    id: "m-43972e2214fa9618",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_161135.jpg",
  },
  {
    id: "m-762010426fdd9748",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_171448.jpg",
  },
  {
    id: "m-372649ab8915efcb",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_171513.jpg",
  },
  {
    id: "m-a2567f67733e2147",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_171534.jpg",
  },
  {
    id: "m-427a5ea677472440",
    batchId: "owner-fluxus-travel-notes",
    category: "fluxus",
    sourceFilename: "20260924_171601.jpg",
  },
  {
    id: "m-8d9c3751e3308471",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260917_143838.jpg",
  },
  {
    id: "m-65e84b90a02e24e7",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260918_141957.jpg",
  },
  {
    id: "m-91c290ad7fe1cd0c",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260918_142107.jpg",
  },
  {
    id: "m-a1fa7a65b98e6c95",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260918_142232.jpg",
  },
  {
    id: "m-cb4a818149416d0d",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260918_142323.jpg",
  },
  {
    id: "m-3fccffddd849ded5",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260918_142403.jpg",
  },
  {
    id: "m-393043ea5b08237c",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260918_142440.jpg",
  },
  {
    id: "m-3d0b225c0d2ec67a",
    batchId: "owner-tea-and-teapots-2024",
    category: "painting",
    sourceFilename: "20260918_142518.jpg",
  },
  {
    id: "m-1c7e51318474990f",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/01.pdf",
    pdfPath: "documents/minges-eskizai/01.pdf",
  },
  {
    id: "m-6ced70f20fbd32e2",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/02.pdf",
    pdfPath: "documents/minges-eskizai/02.pdf",
  },
  {
    id: "m-bd771e176f6f0f67",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/03.pdf",
    pdfPath: "documents/minges-eskizai/03.pdf",
  },
  {
    id: "m-d277c0a1e2c75da9",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/04.pdf",
    pdfPath: "documents/minges-eskizai/04.pdf",
  },
  {
    id: "m-bf42b814507ddd4f",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/05.pdf",
    pdfPath: "documents/minges-eskizai/05.pdf",
  },
  {
    id: "m-c8fe4b17606d9c8d",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/06.pdf",
    pdfPath: "documents/minges-eskizai/06.pdf",
  },
  {
    id: "m-53bf8864e4cf174c",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/07.pdf",
    pdfPath: "documents/minges-eskizai/07.pdf",
  },
  {
    id: "m-d879ed8e4b7ddba3",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/08.pdf",
    pdfPath: "documents/minges-eskizai/08.pdf",
  },
  {
    id: "m-13c009e480eeb7b5",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/09.pdf",
    pdfPath: "documents/minges-eskizai/09.pdf",
  },
  {
    id: "m-0a0d508c7dd51404",
    batchId: "b-minge-2010",
    category: "drawings",
    originalPath: "documents/minges-eskizai/originals/10.pdf",
    pdfPath: "documents/minges-eskizai/10.pdf",
  },
  {
    id: "m-5d40bdc02423d5e5",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/01.jpg",
  },
  {
    id: "m-155bfe6ed48b0c5c",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/02.jpg",
  },
  {
    id: "m-daaaba4d00d35f00",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/03.pdf",
    pdfPath: "documents/kiolno-eskizai/03.pdf",
  },
  {
    id: "m-4d29bef50722d926",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/04.pdf",
    pdfPath: "documents/kiolno-eskizai/04.pdf",
  },
  {
    id: "m-a0d3359512ba9454",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/05.pdf",
    pdfPath: "documents/kiolno-eskizai/05.pdf",
  },
  {
    id: "m-930738e9bcb360db",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/06.jpg",
  },
  {
    id: "m-555b0debbd93d2b9",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/07.pdf",
    pdfPath: "documents/kiolno-eskizai/07.pdf",
  },
  {
    id: "m-56a696dbd1aea4b7",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/08.pdf",
    pdfPath: "documents/kiolno-eskizai/08.pdf",
  },
  {
    id: "m-85bded75f54fc6c1",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/09.pdf",
    pdfPath: "documents/kiolno-eskizai/09.pdf",
  },
  {
    id: "m-9916bfaedb346cff",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/10.pdf",
    pdfPath: "documents/kiolno-eskizai/10.pdf",
  },
  {
    id: "m-e4c2bf835380474c",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/11.pdf",
    pdfPath: "documents/kiolno-eskizai/11.pdf",
  },
  {
    id: "m-ff1999dd7dfabfb4",
    batchId: "b-ced4d9980459",
    category: "drawings",
    originalPath: "documents/kiolno-eskizai/originals/12.pdf",
    pdfPath: "documents/kiolno-eskizai/12.pdf",
  },
] as const;
